import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTill } from '../context/TillContext';
import './TillStatusPill.css';

/**
 * Compact header pill showing the cashier's current till state.
 * Green when a till is open; amber when none is active.
 */
const TillStatusPill: React.FC = () => {
  const { activeTill, loading } = useTill();
  const { t }    = useTranslation();
  const navigate = useNavigate();

  if (loading) return null;

  if (activeTill) {
    return (
      <div className="till-pill till-pill--open">
        <span className="till-pill__dot" />
        <span className="till-pill__label">
          {t('till.statusPillOpen')} — {activeTill.sessionNumber}
        </span>
        <button
          className="till-pill__action"
          onClick={() => navigate('/sales/till/close')}
          title={t('till.closeTill')}
        >
          {t('till.pillClose')}
        </button>
      </div>
    );
  }

  return (
    <div className="till-pill till-pill--closed">
      <span className="till-pill__dot" />
      <span className="till-pill__label">{t('till.statusPillClosed')}</span>
      <button
        className="till-pill__action"
        onClick={() => navigate('/sales/till/open')}
        title={t('till.openTill')}
      >
        {t('till.pillOpen')}
      </button>
    </div>
  );
};

export default TillStatusPill;
